import SketchAdminSketchOrderClient from '../lib/apiClients/roofSnapApiClient/sketchAdminSketchOrderClient';
import { CALL_API } from '../middleware/api';
import {
    CREATE_SKETCH_ORDER_NOTIFICATION_REQUEST,
    CREATE_SKETCH_ORDER_NOTIFICATION_SUCCESS,
    CREATE_SKETCH_ORDER_NOTIFICATION_FAILURE,
    UPDATE_SKETCH_ORDER_NOTIFICATION_REQUEST,
    UPDATE_SKETCH_ORDER_NOTIFICATION_SUCCESS,
    UPDATE_SKETCH_ORDER_NOTIFICATION_FAILURE,
} from './actionTypes';
import { getNotifications } from './sketchOrderNotificationsActions';

export const createNotification = (sketchOrderId, body) => {
    return async (dispatch) => {
        const adminSketchOrderClient = new SketchAdminSketchOrderClient('v2');
        const request = adminSketchOrderClient.createNotification;

        const params = {
            sketchOrderId,
            body,
        };

        const createNotificationAction = await dispatch({
            [CALL_API]: {
                types: [
                    CREATE_SKETCH_ORDER_NOTIFICATION_REQUEST,
                    CREATE_SKETCH_ORDER_NOTIFICATION_SUCCESS,
                    CREATE_SKETCH_ORDER_NOTIFICATION_FAILURE,
                ],
                request,
                params,
            }
        });

        dispatch(getNotifications(sketchOrderId));

        return createNotificationAction;
    };
};

export const updateNotification = (sketchOrderId, id, body, version) => {
    return async (dispatch) => {
        const adminSketchOrderClient = new SketchAdminSketchOrderClient('v2');
        const request = adminSketchOrderClient.updateNotification;

        const params = {
            sketchOrderId,
            id,
            body,
            version,
        };

        const updateNotificationAction = await dispatch({
            [CALL_API]: {
                types: [
                    UPDATE_SKETCH_ORDER_NOTIFICATION_REQUEST,
                    UPDATE_SKETCH_ORDER_NOTIFICATION_SUCCESS,
                    UPDATE_SKETCH_ORDER_NOTIFICATION_FAILURE,
                ],
                request,
                params,
            }
        });

        dispatch(getNotifications(sketchOrderId));

        return updateNotificationAction;
    };
};

export const removeNotification = (sketchOrderId, id) => {
    return async (dispatch) => {
        const adminSketchOrderClient = new SketchAdminSketchOrderClient('v2');
        const request = adminSketchOrderClient.deleteNotification;

        const params = {
            sketchOrderId,
            id,
        };

        const removeNotificationAction = await dispatch({
            [CALL_API]: {
                types: [
                    UPDATE_SKETCH_ORDER_NOTIFICATION_REQUEST,
                    UPDATE_SKETCH_ORDER_NOTIFICATION_SUCCESS,
                    UPDATE_SKETCH_ORDER_NOTIFICATION_FAILURE,
                ],
                request,
                params,
            }
        });

        dispatch(getNotifications(sketchOrderId));

        return removeNotificationAction;
    };
};
